import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconCctvLine,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import { publicCrosswalk1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicCrosswalk/img/1.avif';
import image2 from '@src/assets/images/solution/publicCrosswalk/img/2.avif';
import image3 from '@src/assets/images/solution/publicCrosswalk/img/3.avif';
import image4 from '@src/assets/images/solution/publicCrosswalk/img/4.avif';
import image5 from '@src/assets/images/solution/publicCrosswalk/img/5.avif';
import image6 from '@src/assets/images/solution/publicCrosswalk/img/6.avif';
import image7 from '@src/assets/images/solution/publicCrosswalk/img/7.avif';
import recommendation from '../common/recommendation';

export default {
  type: '도시 안전 솔루션',

  recommend: {
    title: '카메라로 보행자 움직임을 감지하고 차량에 실시간 경고를 전송합니다',
    desc: '횡단보도 주변에 설치된 AI 카메라가 보행자의 이동을 감지하고, 분석 서버를 통해 차량에게 위험 경고를 시각적으로 전달합니다',
    labels: {
      desktop: [
        {
          img: publicCrosswalk1,
          data: recommendation.ptzCamera,
        },
        {
          img: recommendationEdge,
          data: recommendation.edgeRtls,
        },
        {
          img: recommendationSwitch,
          data: recommendation.switch,
        },
      ],
      mobile: [
        {
          data: recommendation.ptzCamera,
        },
        {
          data: recommendation.edgeAi,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },

  banner: {
    title: '보행자의 움직임을 실시간으로 감지해 교차로 사고를 사전에 방지하세요',
    desc: 'AI 기반 감지 기술로 횡단보도 주변의 보행자를 식별하고 차량에게 위험 상황을 자동으로 경고합니다',
  },

  numOfCard: {
    title: 'AI로 교차로 사고를 완전히 차단 하세요.',
    desc: 'AI가 객체를 실시간으로 감지하고 양방향 경고를 전달해, 우회전 교차로의 보행자 사고를 제로(0)화합니다.',
    card: [
      {
        tag: '99.9%',
        title: '객체 인식 정확도',
        desc: '보행자, 자전거, 킥보드 등을 정밀하게 탐지',
      },
      {
        tag: '100개+',
        title: '동시 인식 가능 객체 수',
        desc: '복수 객체를 실시간으로 추적 가능',
      },
      {
        tag: '0건',
        title: '시스템 설치 후 사망 사고',
        desc: '우회전 교차로 사망 사고 완전 차단',
      },
      {
        tag: '0건',
        title: '시스템 설치 후 부상 사고',
        desc: '감지 후 경고를 통해 모든 충돌을 예방',
      },
    ],
  },

  func: [
    {
      theme: '차량과 보행자의 충돌 위험을 정확히 감지하고 즉각 경고합니다.',
      title: '차량 및 보행자 이동 실시간 AI 분석',
      desc: 'AI가 차량과 보행자의 위치, 속도, 이동 방향을 실시간으로 인식합니다. 어린이, 유모차, 자전거, 킥보드 등 다양한 객체를 정확히 감지하며, 교차로나 시야가 제한된 구간에서도 누락 없이 포착할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '실시간 현황 파악',
      icon2: IconClockGray,
      image: image2,
    },
    {
      title: '상대 위치와 이동 방향을 기반으로 충돌 위험 판단',
      desc: '각 객체의 궤적 정보와 속도, 방향 등을 종합해 경로가 교차하거나 일정 거리 이내로 접근하는 경우 위험 상황으로 판단합니다. 단순 감지를 넘어, 실제 충돌 가능성이 있는 경우에만 경고를 작동시켜 정확성과 신뢰도를 높입니다.',
      sub2: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub1: '빠른 데이터 연동',
      icon2: IconTvocGray,
      image: image3,
    },
    {
      title: '전광판을 통한 양방향 경고 실시간 알림',
      desc: '교차로 양측에 설치된 경고 사이니지를 통해 차량 운전자에게는 보행자 접근을, 보행자에게는 차량 접근을 동시에 명확히 알립니다. 효과적인 양방향 정보 전달로 사고 위험을 크게 낮춥니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image4,
    },
    {
      theme: '효율적 구축 및 간편한 운영 관리로 최적의 안전을 제공합니다.',
      title: '오브로 엣지 AI를 이용한 독립적 데이터 보호',
      desc: '현장 내 독립 서버 설치로 데이터를 안전하게 보호하며 외부 유출을 방지합니다. 온프레미스 방식으로 운영하여 개인정보 보호와 데이터 보안을 철저히 유지하고 운영 관리 효율성을 높입니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: '사고 빈번 지역 및 맞춤형 설치 가능',
      desc: '사고가 빈번히 발생하는 교차로나 어린이 보호구역 등 특정 환경에 맞추어 AI 영상 분석 시스템을 설치하고 효율적으로 운영합니다. 지역의 특성과 상황에 따라 맞춤형 안전 관리가 가능합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '다양한 제조사 카메라 연동 지원',
      desc: '여러 제조사의 카메라와 손쉽게 연동할 수 있어 기존 인프라 활용성이 뛰어나며, 향후 확장성 및 교체 작업이 간편합니다.',
      sub1: '자유로운 범위 설정',
      icon1: IconZoneGray,
      sub2: '여러 구역 설정',
      icon2: IconTagGray,
      image: image7,
    },
  ],

  subfunc: {
    title: '기능 요약',
    desc: '작업자의 안전을 보장하는 것은 효율성을 높이고 사고로 인한 손실을 줄입니다. 오브로는 건설 현장 작업자의 안전을 지키기 위해서 최적의 기능들을 구성하였습니다. 작업자가 위험 지역에 다가거나 사고가 발생했을 때, 또는 중장비가 가진 잠재적 위험상황을 포함하여 발생할 수 있는 안전사고에 적절히 대응하도록 시스템을 구축하였습니다.',
    data: [
      {
        icon: IconWarning, // 보행자 위험 → 실시간 경고
        title: '보행자 위험 감지',
        desc: '차량과 보행자의 위치와 속도를 인식해 충돌 위험을 실시간으로 감지합니다.',
      },
      {
        icon: IconAnalytics, // 궤적 예측 → 분석 기반 판단
        title: '충돌 가능성 예측 판단',
        desc: '상대 궤적과 속도 방향을 분석해 실제 충돌 가능성에 따라 경고를 발송합니다.',
      },
      {
        icon: IconLayers, // 양방향 경고 → 시각 경고 정보 표출
        title: '양방향 경고 사이니지',
        desc: '운전자와 보행자 모두에게 위험 상황을 동시에 시각적으로 경고합니다.',
      },
      {
        icon: IconSearch, // 온프레미스 → 탐색/로컬 처리 의미
        title: '온프레미스 데이터 처리',
        desc: '영상 데이터를 외부 서버 없이 현장 서버에서 실시간 분석해 보안을 강화합니다.',
      },
      {
        icon: IconLayers, // 맞춤 설치 → 장소/조건 기반 맞춤형 구성
        title: '위험지역 맞춤 설치',
        desc: '사고 다발 구간이나 보호구역 등 현장 조건에 맞춰 시스템을 유연하게 배치합니다.',
      },
      {
        icon: IconAnalytics, // 객체 인식 → 정밀 인식/분석 의미
        title: '다양한 객체 정밀 인식',
        desc: '어린이, 유모차, 킥보드 등 다양한 객체를 누락 없이 정밀하게 인식합니다.',
      },
      {
        icon: IconCctvLine, // 제조사 호환 → CCTV 연동
        title: '카메라 제조사 호환성 확보',
        desc: '다양한 제조사의 CCTV와 연동돼 기존 인프라 기반으로 즉시 적용이 가능합니다.',
      },
      {
        icon: IconAnalytics, // 행동 기반 기록 분석 → 데이터 기반 개선
        title: '행동 기반 경보 기록 분석',
        desc: '감지된 위험 행동의 데이터를 저장해 사후 분석과 개선에 활용할 수 있습니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'workerPackage',
    },
    {
      tag: 'assetPackage',
    },
  ],

  contents: [
    {
      data: 'constructionAsset',
    },
    {
      data: 'constructionEquipment',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogMedical',
    },
  ],
};
